import React from 'react';
import { FormattedMessage } from 'react-intl';

export const UnsavedChangesText = () => (
  <FormattedMessage id="unsavedChangesPrompt.text" />
);

export default UnsavedChangesText;
